import Tooltip from "@mui/material/Tooltip";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme, defaultOLTheme } from "contexts/Theme/ThemeProvider";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    BarGraphContainer: ({
      chartHeight,
      chartWidth,
    }: {
      chartHeight: number | undefined;
      chartWidth: number | undefined;
    }) => ({
      borderRadius: theme.spacing(1),
      display: "flex",
      height: chartHeight || 12,
      overflow: "hidden",
      width: chartWidth || 165,
    }),
    BarGraphItem: {
      flex: 1,
    },
  }),
);
type Props = {
  chartHeight?: number;
  chartItems: Array<{
    itemColor?: string;
    itemShare: number;
  }>;
  chartWidth?: number;
  className?: string;
  tooltip?: string;
};
const defaultColors = [defaultOLTheme.primary500, defaultOLTheme.primary200];
export function BarChart({
  chartHeight,
  chartItems = [{ itemShare: 50 }, { itemShare: 50 }],
  chartWidth,
  className = "",
  tooltip = "",
}: Props) {
  const classes = useStyles({ chartHeight, chartWidth });

  return (
    <Tooltip
      arrow
      placement="top"
      title={tooltip}
      disableHoverListener={tooltip === ""}
    >
      <span className={`${classes.BarGraphContainer} ${className}`}>
        {chartItems.map((item, index) => (
          <span
            className={classes.BarGraphItem}
            key={index}
            style={{
              background: item.itemColor || defaultColors[index],
              flex: item.itemShare < 0 ? 0 : item.itemShare,
            }}
          />
        ))}
      </span>
    </Tooltip>
  );
}
